import { ComponentRef, Directive, inject, Input, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { takeUntil } from 'rxjs/operators';
import { ContactsListContextMenuComponent } from '../components/contacts-list-context-menu/contacts-list-context-menu.component';
import { ContactListStateService } from '../services/contact-list-state.service';

@Directive({
  selector: '[appContactsListContextMenu]',
  standalone: false,
})
export class ContactsListContextMenuDirective extends ContextMenuDirective implements OnInit {
  @Input() appContactsListContextMenuWithAdvancedSearch: boolean;
  @Input() appContactsListContextMenuWithScore: boolean;
  @Input() stchPopoverTrigger: PopoverTrigger = 'click';
  @Input() stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly contactListStateService = inject(ContactListStateService);

  protected override registerInstance(componentRef: ComponentRef<ContactsListContextMenuComponent>) {
    componentRef.instance.state = this.contactListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appContactsListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appContactsListContextMenuWithScore;
  }

  protected override registerComponent() {
    return ContactsListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.contactListStateService
      .value()
      .pipe(takeUntil(this.alive))
      .subscribe((listState) => {
        this.isDefaultStateObservable?.next(listState.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.contactListStateService.state.isDefault()) {
        this.contactListStateService.state.resetToDefault();
      }
    });
  }
}
